import './MobileNavbar.scss';

import { Link } from 'react-router-dom';
import classNames from 'classnames';

export function MobileNavbarItem({ path, icon, text, isActive }) {
  return (
    <Link
      to={path}
      className={classNames('mobile-navbar-item', isActive ? 'is-active' : '')}
    >
      {icon}
      <p>{text}</p>
    </Link>
  );
}
